import React from 'react';
import ReactDOM from 'react-dom/client';
import type { ProviderPartnershipProps } from '~/types/Provider';
import { ProviderPartnership } from '~/pages/Provider/Partnership/ProviderPartnership';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ProviderPartnershipProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ProviderPartnership {...data} />
  </React.StrictMode>
);
